var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row mt-4" }, [
      _c(
        "div",
        { staticClass: "col-12 ea-reports" },
        _vm._l(_vm.reports, function(item, rindex) {
          return _c("div", { key: rindex, staticClass: "ea-reports-border" }, [
            _c("div", { staticClass: "report_heading_1" }, [
              _vm._v(_vm._s(item.name))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "report_heading_2" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary btn-sm btn-view-report",
                    attrs: { to: item.link }
                  },
                  [
                    _vm._v(
                      "\n                    View Report\n                "
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" })
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49abd134", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49abd134","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/reports_tab.vue
// module id = null
// module chunks = 